import { useEffect, useState } from "react";

const API = process.env.REACT_APP_BACKEND_URL;
const cache = {};

export const useAiPosts = (lang) => {
  const [state, setState] = useState(() => ({ lang, posts: cache[lang] || [], loading: !cache[lang] }));
  const stale = state.lang !== lang;

  useEffect(() => {
    if (cache[lang]) {
      setState({ lang, posts: cache[lang], loading: false });
      return;
    }
    let alive = true;
    fetch(`${API}/api/blog/articles?lang=${lang}`)
      .then((r) => (r.ok ? r.json() : []))
      .then((posts) => {
        const mapped = posts.map((p) => ({ ...p, image: p.image.startsWith("/") ? `${API}${p.image}` : p.image }));
        cache[lang] = mapped;
        if (alive) setState({ lang, posts: mapped, loading: false });
      })
      .catch(() => alive && setState({ lang, posts: [], loading: false }));
    return () => { alive = false; };
  }, [lang]);

  return stale ? { posts: [], loading: true } : state;
};
